module.exports = __webpack_public_path__ + "img/occupation_inf_3.9f0255f9.png";